import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const PlatformMobile16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9 15C11.7284 15 12.4 14.3284 12.4 13.5V13.5C12.4 13.0168 12.0082 12.625 11.525 12.625H4.875C4.39175 12.625 4 13.0168 4 13.5V13.5C4 14.3284 4.67157 15 5.5 15L10.9 15ZM5 11.375C4.44772 11.375 4 10.9273 4 10.375L4 2.5C4 1.67157 4.67157 1 5.5 1H10.9C11.7284 1 12.4 1.67157 12.4 2.5L12.4 10.375C12.4 10.9273 11.9523 11.375 11.4 11.375H5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
